<template>
  <Head title="Confirm password" />
  <div
    class="min-vh-100 d-flex align-items-center justify-content-center bg-light"
  >
    <DContainer class="py-5">
      <DRow class="justify-content-center">
        <DCol sm="10" md="8" lg="6" xl="4">
          <DCard>
            <h3 class="text-center mb-2">Confirm your password</h3>
            <p class="text-muted text-center small mb-4">
              This is a secure area. Please confirm your password to continue.
            </p>

            <DXForm
              :form="confirmForm"
              submit-text="Confirm"
              submit-loading-text="Confirming..."
              @submit="handleConfirm"
            />
          </DCard>
        </DCol>
      </DRow>
    </DContainer>
  </div>
</template>

<script setup lang="ts">
import { Head } from "@inertiajs/vue3";
import {
  defineForm,
  DXForm,
  DContainer,
  DRow,
  DCol,
  DCard,
} from "@omnitend/dashboard-for-laravel";

// Fallback page for a plain browser navigation to /user/confirm-password. The
// SPA itself never lands here: dfl sends `Accept: application/json`, so the
// `password.confirm` middleware answers 423 and the Security page prompts
// inline instead (see Security.vue).
const confirmForm = defineForm([
  {
    key: "password",
    type: "password",
    label: "Password",
    placeholder: "Enter your password",
    required: true,
    default: "",
    autocomplete: "current-password",
  },
] as const);

const handleConfirm = async () => {
  try {
    await confirmForm.form.post("/user/confirm-password");
    window.location.href = "/security";
  } catch {
    // 422 — dfl has set form.errors and DXForm renders them.
  }
};
</script>
